import { render, staticRenderFns } from "./ProviderV2Cmp.vue?vue&type=template&id=58021dca&scoped=true"
import script from "./ProviderV2Cmp.vue?vue&type=script&lang=js"
export * from "./ProviderV2Cmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58021dca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58021dca')) {
      api.createRecord('58021dca', component.options)
    } else {
      api.reload('58021dca', component.options)
    }
    module.hot.accept("./ProviderV2Cmp.vue?vue&type=template&id=58021dca&scoped=true", function () {
      api.rerender('58021dca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/cmp/Query/ProviderV2Cmp.vue"
export default component.exports